export default "__VITE_ASSET__686tB1KB__"